import React from 'react'
import styled from 'styled-components'
import { useLocalLabels } from '@sentecacommerce-theme/lib'
import { ProductPageLabels } from '../../productPage.props'
import { ProductRating } from '../ProductRating'
import { Typography } from '../../../Common'

export const ReviewTabContent = ({ stars }: ReviewTabContentProps) => {
  const labels = useLocalLabels<ProductPageLabels>()
  return (
    <>
      <ReviewContent>
        <ProductRating idPrefix="tab-" value={stars} smallMargin />
        <span>{`${stars} ${labels?.stars}`}</span>
      </ReviewContent>
      <WriteReview>{labels?.writeAReview}</WriteReview>
    </>
  )
}

export type ReviewTabContentProps = {
  stars?: number
}

const ReviewContent = styled(Typography).attrs({
  color: 'titleGrey',
})<any>`
  display: flex;
  align-items: center;
  & > span {
    margin-left: 1.2rem;
  }
`

const WriteReview = styled.span`
  box-shadow: inset 0 -1px 0 0 #111;
  border-radius: 0;
  cursor: pointer;
  width: fit-content;
  font-size: 16px;
  font-weight: 600;
  display: block;
  margin-top: 1rem;
`
